const treeData = [
    [ // Alchemist
        {
            skillID: 'formula_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 8
        },
        {
            skillID: 'fire_formula',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'ice_formula',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1]
        },
        {
            skillID: 'volt_formula',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1]
        },
        {
            skillID: 'inferno_formula',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5]
        },
        {
            skillID: 'cocytus_formula',
            baseSkill: false,
            coords: {x: 1, y: 2},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5]
        },
        {
            skillID: 'thor_formula',
            baseSkill: false,
            coords: {x: 1, y: 3},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5]
        },
        {
            skillID: 'flame_formula',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'freeze_formula',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'spark_formula',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'dilution',
            baseSkill: false,
            coords: {x: 1, y: 5},
            numAfter: 0,
            numBefore: 3,
            beforeStyle: 'centered'
        },
        {
            skillID: 'analysis',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [7],
        },
        {
            skillID: 'pain_formula',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'firelight',
            baseSkill: false,
            coords: {x: 1, y: 8},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'light_formula',
            baseSkill: false,
            coords: {x: 2, y: 8},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'light_tincture',
            baseSkill: false,
            coords: {x: 2, y: 9},
            numAfter: 0,
            numBefore: 1,
        },
        {
            skillID: 'tp_up',
            baseSkill: true,
            coords: {x: 0, y: 10},
            barSize: 5
        },
        {
            skillID: 'return_formula',
            baseSkill: false,
            coords: {x: 0, y: 11},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'flee',
            baseSkill: false,
            coords: {x: 1, y: 11},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'alchemy',
            baseSkill: false,
            coords: {x: 0, y: 12},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [2],
        },
        {
            skillID: 'scavenge',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'sight_formula',
            baseSkill: false,
            coords: {x: 0, y: 14},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'focus',
            baseSkill: false,
            coords: {x: 0, y: 15},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'chop',
            baseSkill: true,
            coords: {x: 0, y: 16},
            numAfter: 0,
            numBefore: 0,
        },
    ],
    [ // Dark Hunter
        {
            skillID: 'whip_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 5
        },
        {
            skillID: 'gag',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [7],
        },
        {
            skillID: 'shackles',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [7],
        },
        {
            skillID: 'cuffs',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [7],
        },
        {
            skillID: 'ecstasy',
            baseSkill: false,
            coords: {x: 1, y: 2},
            numAfter: 0,
            numBefore: 3,
            beforeStyle: 'centered'
        },
        {
            skillID: 'viper',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'climax',
            baseSkill: false,
            coords: {x: 1, y: 5},
            numAfter: 0,
            numBefore: 1,
            beforeSkip: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'sword_mastery',
            baseSkill: true,
            coords: {x: 0, y: 6},
            barSize: 5
        },
        {
            skillID: 'hypno_bite',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [7],
        },
        {
            skillID: 'nerve_bite',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [7],
        },
        {
            skillID: 'mirage_bite',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [7],
        },
        {
            skillID: 'soul_liberator',
            baseSkill: false,
            coords: {x: 1, y: 8},
            numAfter: 0,
            numBefore: 3,
            beforeStyle: 'centered',
        },
        {
            skillID: 'drain_bite',
            baseSkill: false,
            coords: {x: 0, y: 10},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'catastrophe',
            baseSkill: false,
            coords: {x: 1, y: 11},
            numAfter: 0,
            numBefore: 1,
            beforeSkip: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'atk_up',
            baseSkill: true,
            coords: {x: 0, y: 12},
            barSize: 2
        },
        {
            skillID: 'boost_up',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'wraths_might',
            baseSkill: false,
            coords: {x: 0, y: 14},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'bait',
            baseSkill: false,
            coords: {x: 1, y: 13},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'tp_up',
            baseSkill: true,
            coords: {x: 0, y: 15},
            barSize: 2
        },
        {
            skillID: 'bind_heart',
            baseSkill: false,
            coords: {x: 0, y: 16},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [2],
        },
        {
            skillID: 'shadow_veil',
            baseSkill: false,
            coords: {x: 0, y: 17},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [2],
        },
        {
            skillID: 'dark_curse',
            baseSkill: false,
            coords: {x: 1, y: 16},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 18}
        },
        {
            skillID: 'take',
            baseSkill: true,
            coords: {x: 1, y: 18}
        }
    ],
    [ // Gunner
        {
            skillID: 'gun_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 9
        },
        {
            skillID: 'head_snipe',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'arm_snipe',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'leg_snipe',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'fire_rounds',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'charged_fire',
            baseSkill: false,
            coords: {x: 1, y: 4},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'ice_rounds',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'charged_ice',
            baseSkill: false,
            coords: {x: 1, y: 5},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'volt_rounds',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'charged_volt',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'charged_shot',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'penetrator', // GIVE PENETRATOR 2 LINES
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [7],
            postReqLevels: [3],
        },
        {
            skillID: 'recharge',
            baseSkill: false,
            coords: {x: 1, y: 7.5},
            numAfter: 0,
            numBefore: 2,
            beforeStyle: 'centered',
        },
        {
            skillID: 'ricochet',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [10],
            postReqLevels: [3],
        },
        {
            skillID: 'action_boost',
            baseSkill: false,
            coords: {x: 1, y: 8.5},
            numAfter: 0,
            numBefore: 1,
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 10},
            barSize: 2
        },
        {
            skillID: 'medic_bullet',
            baseSkill: false,
            coords: {x: 0, y: 11},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [3],
        },
        {
            skillID: 'cover_fire',
            baseSkill: false,
            coords: {x: 0, y: 12},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'shell_shock',
            baseSkill: false,
            coords: {x: 1, y: 11},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'atk_up',
            baseSkill: true,
            coords: {x: 0, y: 13},
            barSize: 2
        },
        {
            skillID: 'high_caliber',
            baseSkill: false,
            coords: {x: 0, y: 14},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [3],
        },
        {
            skillID: 'vulcan_stance',
            baseSkill: false,
            coords: {x: 0, y: 15},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'double_strike',
            baseSkill: false,
            coords: {x: 1, y: 14},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'take',
            baseSkill: true,
            coords: {x: 0, y: 16},
        },
    ],
    [ // Hexer
        {
            skillID: 'curse_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 9,
            numBefore: 0,
            numAfter: 0
        },
        {
            skillID: 'sapping_curse',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'frailty_curse',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'leaden_curse',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [2],
            postReqLevels: [5],
        },
        {
            skillID: 'deceit_curse',
            baseSkill: false,
            coords: {x: 1, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [2],
            postReqLevels: [5],
        },
        {
            skillID: 'revenge_curse',
            baseSkill: false,
            coords: {x: 2, y: 1.5},
            numAfter: 0,
            numBefore: 1,
        },
        {
            skillID: 'blinding_curse',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [2],
        },
        {
            skillID: 'madness_curse',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'torpor_curse',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [2],
        },
        {
            skillID: 'corrupt_curse',
            baseSkill: false,
            coords: {x: 1, y: 3.5},
            numAfter: 1,
            numBefore: 1,
            postReqLevels: [3],
        },
        {
            skillID: 'stoning_curse',
            baseSkill: false,
            coords: {x: 1, y: 4.5},
            numAfter: 1,
            numBefore: 1,
            postReqLevels: [3],
        },
        {
            skillID: 'relapse_curse',
            baseSkill: false,
            coords: {x: 2, y: 4},
            numAfter: 0,
            numBefore: 2,
            beforeStyle: 'centered'
        },
        {
            skillID: 'cranial_curse',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'abdomen_curse',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'immobile_curse',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'evil_eye',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 4,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'luring_whisper',
            baseSkill: false,
            coords: {x: 1, y: 9},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'muting_word',
            baseSkill: false,
            coords: {x: 1, y: 10},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'conflict_word',
            baseSkill: false,
            coords: {x: 1, y: 11},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'suicide_word',
            baseSkill: false,
            coords: {x: 1, y: 12},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'tp_up',
            baseSkill: true,
            coords: {x: 0, y: 13},
            numAfter: 1,
            numBefore: 0,
            barSize: 1
        },
        {
            skillID: 'staggering_word',
            baseSkill: false,
            coords: {x: 0, y: 14},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'hp_up',
            baseSkill: false,
            coords: {x: 1, y: 13},
            numAfter: 0,
            numBefore: 0,
        },
        {
            skillID: 'chop',
            baseSkill: false,
            coords: {x: 2, y: 13},
            numBefore: 0,
            numAfter: 0
        },
        
    ],
    [ // Highlander
        {
            skillID: 'spear_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 6
        },
        {
            skillID: 'long_thrust',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'draining_thrust',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [2],
        },
        {
            skillID: 'draining_burst',
            baseSkill: false,
            coords: {x: 1, y: 2},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'legion_thrust',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [2],
        },
        {
            skillID: 'legion_burst',
            baseSkill: false,
            coords: {x: 1, y: 3},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'head_pierce',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'spear_assist',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'delayed_charge',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'cross_charge',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'atk_up',
            baseSkill: true,
            coords: {x: 0, y: 7},
            barSize: 3
        },
        {
            skillID: 'turning_tide',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [3],
        },
        {
            skillID: 'bloody_offense',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'bloodlust',
            baseSkill: false,
            coords: {x: 1, y: 8},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'stigmata',
            baseSkill: false,
            coords: {x: 0, y: 10},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'def_up',
            baseSkill: true,
            coords: {x: 0, y: 11},
            barSize: 3
        },
        {
            skillID: 'battle_instinct',
            baseSkill: false,
            coords: {x: 0, y: 12},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [3],
        },
        {
            skillID: 'blood_fortune',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'allied_bonds',
            baseSkill: false,
            coords: {x: 1, y: 12},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'spirit_shield',
            baseSkill: false,
            coords: {x: 0, y: 14},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 15},
            barSize: 2
        },
        {
            skillID: 'limitless',
            baseSkill: false,
            coords: {x: 0, y: 16},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'black_sabbath',
            baseSkill: false,
            coords: {x: 0, y: 17},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'mine',
            baseSkill: false,
            coords: {x: 1, y: 15}
        },
    ],
    [ // Landsknecht
        {
            skillID: 'sword_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 4,
            numBefore: 0,
            numAfter: 0
        },
        {
            skillID: 'raging_edge',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'tornado',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            afterSkip: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'blinding_slap',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'falcon_slash',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'axe_mastery',
            baseSkill: true,
            coords: {x: 0, y: 5},
            barSize: 4,
            numBefore: 0,
            numAfter: 0
        },
        {
            skillID: 'boomerang_axe',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'head_bash',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [3],
        },
        {
            skillID: 'stunning_smash',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 1,
            numBefore: 1,
            afterSkip: 1,
            preReqLevels: [5],
            postReqLevels: [5],
        },
        {
            skillID: 'power_crush',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'double_strike',
            baseSkill: false,
            coords: {x: 1, y: 5},
            numAfter: 0,
            numBefore: 5, // really only 2 but need to make line longer
            beforeStyle: 'centered',
        },
        {
            skillID: 'ice_chaser',
            baseSkill: false,
            coords: {x: 2, y: 5},
            numAfter: 0,
            numBefore: 7, // really only 2 but need to make line longer
            beforeStyle: 'centered',
        },
        {
            skillID: 'fire_chaser',
            baseSkill: false,
            coords: {x: 2, y: 4},
            numAfter: 0,
            numBefore: 1
        },
        {
            skillID: 'volt_chaser',
            baseSkill: false,
            coords: {x: 2, y: 6},
            numAfter: 0,
            numBefore: 1
        },
        {
            skillID: 'def_up',
            baseSkill: true,
            coords: {x: 0, y: 10},
            numAfter: 1,
            numBefore: 0,
            postReqLevels: [3],
        },
        {
            skillID: 'recover',
            baseSkill: false,
            coords: {x: 1, y: 10},
            numAfter: 1,
            numBefore: 1,
            postReqLevels: [3],
        },
        {
            skillID: 'savage_cry',
            baseSkill: false,
            coords: {x: 2, y: 10},
            numBefore: 1,
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 11},
            numAfter: 1,
            numBefore: 0,
            postReqLevels: [2],
        },
        {
            skillID: 'tp_up',
            baseSkill: true,
            coords: {x: 0, y: 12},
            numAfter: 1,
            numBefore: 0,
            postReqLevels: [2],
        },
        {
            skillID: 'triple_charge',
            baseSkill: false,
            coords: {x: 1, y: 11},
            numAfter: 1,
            numBefore: 2,
            postReqLevels: [3],
        },
        {
            skillID: 'atk_up',
            baseSkill: true,
            coords: {x: 0, y: 13},
            numAfter: 1,
            numBefore: 0
        },
        {
            skillID: 'war_cry',
            baseSkill: false,
            coords: {x: 1, y: 13},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'strike_chaser',
            baseSkill: false,
            coords: {x: 2, y: 12},
            numAfter: 0,
            numBefore: 3,
            beforeStyle: 'centered'
        },
        {
            skillID: 'mine',
            baseSkill: true,
            coords: {x: 0, y: 14},
            numAfter: 0,
            numBefore: 0
        },
    ],
    [ // Medic
        {
            skillID: 'heal_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 6
        },
        {
            skillID: 'cure',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'salve',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'unbind',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'refresh',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'immunize',
            baseSkill: false,
            coords: {x: 1, y: 2},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'regenerate',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'delayed_heal',
            baseSkill: false,
            coords: {x: 1, y: 4},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'heal',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [7],
        },
        {
            skillID: 'revive',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'cpr',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 7},
            barSize: 5,
            numBefore: 0,
            numAfter: 0
        },
        {
            skillID: 'anaesthetic',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'toxin_injection',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'curare',
            baseSkill: false,
            coords: {x: 0, y: 10},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'diagnosis',
            baseSkill: false,
            coords: {x: 0, y: 11},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'clear_strike',
            baseSkill: false,
            coords: {x: 0, y: 12},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'tp_up',
            baseSkill: true,
            coords: {x: 2, y: 7},
            barSize: 3,
            numBefore: 0,
            numAfter: 0
        },
        {
            skillID: 'safe_passage',
            baseSkill: false,
            coords: {x: 2, y: 8},
            numAfter: 0,
            numBefore: 1,
            baseBefore: true,
            preReqLevels: [1],
        },
        {
            skillID: 'scavenge',
            baseSkill: false,
            coords: {x: 2, y: 9},
            numAfter: 0,
            numBefore: 1,
            baseBefore: true,
            preReqLevels: [3],
        },
        {
            skillID: 'focus',
            baseSkill: false,
            coords: {x: 2, y: 10},
            numAfter: 0,
            numBefore: 1,
            baseBefore: true,
            preReqLevels: [10],
        },
        {
            skillID: 'atk_up',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 1,
            numBefore: 0
        },
        {
            skillID: 'caduceus',
            baseSkill: false,
            coords: {x: 1, y: 13},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'chop',
            baseSkill: false,
            coords: {x: 2, y: 13},
            numAfter: 0,
            numBefore: 0,
        }
    ],
    [ // Protector
        {
            skillID: 'shield_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 7
        },
        {
            skillID: 'front_guard',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [5],
        },
        {
            skillID: 'rear_guard',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [5],
        },
        {
            skillID: 'defender',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'fire_wall',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'ice_wall',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'volt_wall',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'shield_smite',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [7],
        },
        {
            skillID: 'shield_rush',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'braverys_gift',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'def_up',
            baseSkill: true,
            coords: {x: 0, y: 8},
            barSize: 3
        },
        {
            skillID: 'provoke',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'parry',
            baseSkill: false,
            coords: {x: 1, y: 9},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'fortify',
            baseSkill: false,
            coords: {x: 0, y: 10},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'aegis',
            baseSkill: false,
            coords: {x: 0, y: 11},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [5],
        },
        {
            skillID: 'en_garde',
            baseSkill: false,
            coords: {x: 1, y: 10},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 12},
            barSize: 3
        },
        {
            skillID: 'safe_passage',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'flee',
            baseSkill: false,
            coords: {x: 1, y: 13},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'cure',
            baseSkill: false,
            coords: {x: 0, y: 14},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'party_cure',
            baseSkill: false,
            coords: {x: 0, y: 15},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'prayer',
            baseSkill: false,
            coords: {x: 1, y: 14},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'tp_up',
            baseSkill: false,
            coords: {x: 1, y: 8},
            numAfter: 0,
            numBefore: 0,
        },
        {
            skillID: 'mine',
            baseSkill: false,
            coords: {x: 1, y: 12},
            numAfter: 0,
            numBefore: 0,
        },
    ],
    [ // Ronin
        {
            skillID: 'katana_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 8
        },
        {
            skillID: 'slantwise_cut',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'perfect_chaser',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [7],
        },
        {
            skillID: 'upper_stance',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'horse_slash',
            baseSkill: false,
            coords: {x: 1, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'flame_grater',
            baseSkill: false,
            coords: {x: 2, y: 2},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'swallow_strike',
            baseSkill: false,
            coords: {x: 1, y: 3},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'clear_stance',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'razor_dodge',
            baseSkill: false,
            coords: {x: 1, y: 4},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'lightning_stab',
            baseSkill: false,
            coords: {x: 2, y: 4},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'arm_strike',
            baseSkill: false,
            coords: {x: 1, y: 5},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'drawing_stance',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 2,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'beheading_cut',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'frigid_slash',
            baseSkill: false,
            coords: {x: 2, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'charging_slash',
            baseSkill: false,
            coords: {x: 1, y: 7},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'peerless_stance',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'atk_up',
            baseSkill: true,
            coords: {x: 0, y: 9},
            barSize: 1
        },
        {
            skillID: 'crit_up',
            baseSkill: false,
            coords: {x: 0, y: 10},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'severing_slash',
            baseSkill: false,
            coords: {x: 1, y: 10},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 11},
            numAfter: 1,
            numBefore: 0,
        },
        {
            skillID: 'breath',
            baseSkill: false,
            coords: {x: 1, y: 11},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'tp_up',
            baseSkill: true,
            coords: {x: 0, y: 12},
            numAfter: 1,
            numBefore: 1,
        },
        {
            skillID: 'indomitable_cry',
            baseSkill: false,
            coords: {x: 1, y: 12},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'mine',
            baseSkill: false,
            coords: {x: 1, y: 9},
            numAfter: 0,
            numBefore: 0
        },
    ],
    [ // Survivalist
        {
            skillID: 'bow_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 3
        },
        {
            skillID: 'power_shot',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [5],
        },
        {
            skillID: 'disabling_shot',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [3],
        },
        {
            skillID: 'multi-shot',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'sagittarius_shot',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'agi_up',
            baseSkill: true,
            coords: {x: 0, y: 4},
            barSize: 5
        },
        {
            skillID: 'hasten',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [2],
        },
        {
            skillID: 'trickery',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [2],
            postReqLevels: [2],
        },
        {
            skillID: 'sure_shot',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [2],
        },
        {
            skillID: 'chain_dance',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 1,
            numBefore: 3,
            beforeStyle: 'centered'
        },
        {
            skillID: 'endorphins',
            baseSkill: false,
            coords: {x: 2, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'act_first',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'quick_step',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'predator',
            baseSkill: true,
            coords: {x: 0, y: 10},
            barSize: 3
        },
        {
            skillID: 'owl-eye',
            baseSkill: false,
            coords: {x: 0, y: 11},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'awareness',
            baseSkill: false,
            coords: {x: 0, y: 12},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'stalker',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 14},
            numAfter: 1,
            numBefore: 0,
            barSize: 0
        },
        {
            skillID: 'efficiency',
            baseSkill: false,
            coords: {x: 1, y: 14},
            numBefore: 1,
            numAfter: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'resuscitate',
            baseSkill: false,
            coords: {x: 2, y: 14},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'chop',
            baseSkill: true,
            coords: {x: 0, y: 15},
            numAfter: 0,
            numBefore: 0
        },
        {
            skillID: 'mine',
            baseSkill: true,
            coords: {x: 1, y: 15},
            numAfter: 0,
            numBefore: 0
        },
        {
            skillID: 'take',
            baseSkill: true,
            coords: {x: 2, y: 15},
            numAfter: 0,
            numBefore: 0
        },
    ],
    [ // Troubadour
        {
            skillID: 'song_mastery',
            baseSkill: true,
            coords: {x: 0, y: 0},
            barSize: 9
        },
        {
            skillID: 'warrior_song',
            baseSkill: false,
            coords: {x: 0, y: 1},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [5],
        },
        {
            skillID: 'shelter_song',
            baseSkill: false,
            coords: {x: 0, y: 2},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [1],
            postReqLevels: [5],
        },
        {
            skillID: 'holy_gift',
            baseSkill: false,
            coords: {x: 1, y: 1},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'skanda_song',
            baseSkill: false,
            coords: {x: 0, y: 3},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'insight_melody',
            baseSkill: false,
            coords: {x: 0, y: 4},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'recovery_aria',
            baseSkill: false,
            coords: {x: 1, y: 3},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'fire_prelude',
            baseSkill: false,
            coords: {x: 0, y: 5},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'flame_fantasia',
            baseSkill: false,
            coords: {x: 1, y: 5},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'ice_prelude',
            baseSkill: false,
            coords: {x: 0, y: 6},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'frost_fantasia',
            baseSkill: false,
            coords: {x: 1, y: 6},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'volt_prelude',
            baseSkill: false,
            coords: {x: 0, y: 7},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
        },
        {
            skillID: 'shock_fantasia',
            baseSkill: false,
            coords: {x: 1, y: 7},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'echoing_rondo',
            baseSkill: false,
            coords: {x: 0, y: 8},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [7],
        },
        {
            skillID: 'healing_lullaby',
            baseSkill: false,
            coords: {x: 1, y: 8},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [3],
            postReqLevels: [5],
        },
        {
            skillID: 'eerie_chorus',
            baseSkill: false,
            coords: {x: 0, y: 9},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'peace_ballad',
            baseSkill: false,
            coords: {x: 1, y: 9},
            numAfter: 1,
            numBefore: 1,
            preReqLevels: [5],
            postReqLevels: [5],
        },
        {
            skillID: 'taboo_rondo',
            baseSkill: false,
            coords: {x: 2, y: 8},
            numAfter: 0,
            numBefore: 2,
        },
        {
            skillID: 'hp_up',
            baseSkill: true,
            coords: {x: 0, y: 10},
            barSize: 3
        },
        {
            skillID: 'frightful_yawl',
            baseSkill: false,
            coords: {x: 0, y: 11},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [1],
        },
        {
            skillID: 'restful_tune',
            baseSkill: false,
            coords: {x: 0, y: 12},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [3],
        },
        {
            skillID: 'barbaric_march',
            baseSkill: false,
            coords: {x: 0, y: 13},
            numAfter: 0,
            numBefore: 1,
            preReqLevels: [10],
        },
        {
            skillID: 'tp_up',
            baseSkill: false,
            coords: {x: 1, y: 10},
            barSize: 0
        },
        {
            skillID: 'take',
            baseSkill: false,
            coords: {x: 1, y: 11},
            barSize: 0
        },
        
    ]
]

export default treeData;